<template>
  <b-modal id="modal-limit-select" header-class="warning">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div class=""> 
          <h5> {{$t('engine.filemanager.folder.selectFileExceed.lblTitle', languageEngine)}} </h5>
        </div>
        <div class="d-flex">
          <div class="mr-gd-1">
            <i class="fal fa-question-circle"></i>
          </div>
          <div
            @click="closeModal()"
            id="close-modal-limit-select"
            class="close-modal cursor-pointer"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div>
          {{$t('engine.filemanager.folder.selectFileExceed.lblDetail', languageEngine)}} <span class="text-danger"> {{select}} </span>{{$t('engine.filemanager.folder.selectFileExceed.lblTryAgain', languageEngine, {limit:limit})}}
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="blue" @click="closeModal"> {{$t('engine.common.btnClose', languageEngine)}} </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    })
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-limit-select");
    },
  },
  props:['select','limit','type']
}
</script>